Vue.component('ack-country-selector-modal', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-country-selector-modal',
  mixins: [stringHelpersMixins],
  created() {
    appLog.log('ack-country-selector-modal created')

    

    EventBus.$on('show-country-selector-modal', () => {
      appLog.log('on show-country-selector-modal', LOG_TYPE.debug)
      this.showModal()
    })

    EventBus.$on('hide-country-selector-modal', () => {
      appLog.log('on hide-country-selector-modal', LOG_TYPE.debug)
      this.hideModal()
    })


  },
  mounted(){
    this.modal = new bootstrap.Modal(document.getElementById('country-selector-modal'), {})
  },
  props:{
    // iconItems: { // :product-info
    //   type: Array,
    //   required: true
    // }
  },
  computed: {
    ...Vuex.mapGetters('localization', ['COUNTRY_SELECT', 'countryCode', 'currencyCode', 'currencySymbol' ]),

    countrySelectAsia(){
      return this.COUNTRY_SELECT.filter(m => m.continent === 'Asia'&& m.code !== 'TW')
    },
    countrySelectAfrica(){
      return this.COUNTRY_SELECT.filter(m => m.continent === 'Africa')
    },
    countrySelectEurope(){
      return this.COUNTRY_SELECT.filter(m => m.continent === 'Europe')
    },
    countrySelectCentralAmerica(){
      return this.COUNTRY_SELECT.filter(m => m.continent === 'Central America')
    },
    countrySelectSouthAmerica(){
      return this.COUNTRY_SELECT.filter(m => m.continent === 'South America')
    },
    countrySelectOceania(){
      return this.COUNTRY_SELECT.filter(m => m.continent === 'Oceania')
    },
    countrySelectNorthAmerica(){
      return this.COUNTRY_SELECT.filter(m => m.continent === 'North America')
    },
    countrySelectOthers(){
      return this.COUNTRY_SELECT.filter(m => ((m.continent !== 'North America') && (m.continent !== 'Oceania') && (m.continent !== 'South America') && (m.continent !== 'Central America') && (m.continent !== 'Europe') && (m.continent !== 'Africa') && (m.continent !== 'Asia')))
    },

    arrayContinents(){
      let array = []
      array.push({continent: 'Africa', countries: this.countrySelectAfrica})
      array.push({continent: 'Asia', countries: this.countrySelectAsia})
      array.push({continent: 'Central America', countries: this.countrySelectCentralAmerica})
      array.push({continent: 'Europe', countries: this.countrySelectEurope})
      array.push({continent: 'North America', countries: this.countrySelectNorthAmerica})
      array.push({continent: 'Oceania', countries: this.countrySelectOceania})
      array.push({continent: 'South America', countries: this.countrySelectSouthAmerica})
      //array.push({continent: 'Others', countries: this.countrySelectOthers})
      return array
    }

  },
  data() {
    return {
      modal: null
    }
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])
    showModal(){
      appLog.log('on showModal', LOG_TYPE.debug)
      this.modal.show()
    },
    hideModal(){
      appLog.log('on hideModal', LOG_TYPE.debug)
      this.modal.hide()
    },

    onCountryClick(country){
      this.modal.hide()
      EventBus.$emit('show-country-selector-confirm-modal', country)
    }
  },
  beforeDestroy() {

  },
  watch: {
    isMobile: {
      handler() {


      },
      deep: false
    }
  }
})